import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect, useState } from 'preact/hooks'

import NoResults from './NoResults'
import Products from './Products'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import BottomToolbar from './BottomToolbar'
import Skeleton from './elements/Skeleton'
import useSwatches from './useSwatches'

export default function Category() {
    const [title, setTitle] = useState('')
    const {
        response: { products },
        loading,
    } = useAppState()
    const foundProducts = products && products.total > 0
    const { swatchData } = useSwatches()
    console.log({
        swatchData,
    })

    // Fetch the title
    useEffect(() => {
        const currentUrl = window.location.href
        const baseUrl = currentUrl.split('?')[0]
        const jsonUrl = `${baseUrl}.json`

        fetch(jsonUrl)
            .then((response) => response.json())
            .then((data) => {
                const fetchedTitle = data.collection.title
                setTitle(fetchedTitle)
            })
            .catch((error) => {
                console.error('Error fetching the JSON data:', error)
            })
    }, [])

    const toggleButtonId = 'toggle-mobile-sidebar'

    return (
        <>
            <div className="ns-collection-title">{title}</div>
            <div className="ns-serp page-width ns-d-flex ns-flex-column ns-font-inherit">
                <div className="ns-results-container">
                    {foundProducts ? (
                        <>
                            <Toolbar mobile lableFor={toggleButtonId} />
                            <Sidebar toggleId={toggleButtonId} />
                            <div className="ns-products-wrapper ns-d-block ns-d-md-inline ns-w-100 ns-border-box">
                                <Products swatchData={swatchData} title={title} />
                                <BottomToolbar />
                            </div>
                        </>
                    ) : loading ? (
                        <div className="ns-products-wrapper ns-d-block ns-d-md-inline ns-w-100 ns-border-box">
                            <Skeleton />
                        </div>
                    ) : (
                        <>
                            <Toolbar mobile lableFor={toggleButtonId} />
                            <Sidebar toggleId={toggleButtonId} />
                            <NoResults />
                        </>
                    )}
                </div>
            </div>
        </>
    )
}
